import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Product from '../styled/Product';

const DetailsTitle = styled.h3`
  font-family: 'Avenir Black', 'Arial Black', sans-serif;
  letter-spacing: 1px;
  color: #999;
  text-transform: uppercase;
`;

const ProductTitle = props => {
  const { productName, productUrl, detailed, bright } = props;

  return (
    <Product data-cy="title-product-model" bright={bright}>
      {productUrl ? (
        <a href={productUrl}>{productName}</a>
      ) : detailed ? (
        <DetailsTitle>{productName}</DetailsTitle>
      ) : (
        productName
      )}
    </Product>
  );
};

ProductTitle.defaultProps = {
  productUrl: null,
};

ProductTitle.propTypes = {
  productName: PropTypes.string.isRequired,
  productUrl: PropTypes.string,
};

export default ProductTitle;
